import { render, staticRenderFns } from "./bindH5.vue?vue&type=template&id=229e805c&scoped=true&"
import script from "./bindH5.vue?vue&type=script&lang=js&"
export * from "./bindH5.vue?vue&type=script&lang=js&"
import style0 from "./bindH5.vue?vue&type=style&index=0&id=229e805c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229e805c",
  null
  
)

export default component.exports